/**
 * The minimum balance the release engine actually enforces, in the instructor's
 * own currency, already formatted for display.
 *
 * Every payout line in the instructor onboarding flow reads from here, so a
 * screen can never declare a threshold the engine does not use — the defect
 * this hook exists to remove. `getMinimumPayoutCents` is the frontend mirror of
 * the same map `_shared/payoutLimits.ts` applies when releasing.
 */

import { formatCurrency } from '@/lib/pricing';
import { getMinimumPayoutCents } from '@/lib/payoutLimits';
import { usePayoutCurrency } from './usePayoutCurrency';

export function useFormattedPayoutMinimum(): string {
  const { currency } = usePayoutCurrency();
  return formatCurrency(getMinimumPayoutCents(currency), currency);
}
